var _rect, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCircleGradientPhone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "white",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.8889 16.2524H20.1111C19.8164 16.2524 19.5338 16.374 19.3254 16.5904C19.1171 16.8068 19 17.1003 19 17.4063V30.0986C19 30.4046 19.1171 30.6981 19.3254 30.9145C19.5338 31.1309 19.8164 31.2524 20.1111 31.2524H27.8889C28.1836 31.2524 28.4662 31.1309 28.6746 30.9145C28.8829 30.6981 29 30.4046 29 30.0986V17.4063C29 17.1003 28.8829 16.8068 28.6746 16.5904C28.4662 16.374 28.1836 16.2524 27.8889 16.2524Z",
    stroke: "url(#paint0_linear_675_7107)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23 27.2524H25",
    stroke: "url(#paint1_linear_675_7107)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_675_7107",
    x1: 19,
    y1: 23.7524,
    x2: 29,
    y2: 23.7524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FF00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_675_7107",
    x1: 23,
    y1: 27.7524,
    x2: 25,
    y2: 27.7524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FF00"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleGradientPhone);
export default __webpack_public_path__ + "static/media/circle-gradient-phone.06ed3656c08da73ed6f903f917a76a1e.svg";
export { ForwardRef as ReactComponent };